"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/LBFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_133)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_133`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0.0140381H30V6.37895H-6V0.0140381ZM-5.96491 17.6351H30V24H-5.96491V17.6351Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.3719 13.5789L11.9649 9.17188L9.55786 13.5789H11.3614V14.7859H12.5684V13.5789H14.3719Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.9333 14.9544C11.2421 14.6456 11.2421 14.1403 10.9263 13.8315L11.2562 14.1614C10.8912 13.8315 10.4 13.6982 9.9158 13.7894L8.26668 14.2035C7.83861 14.3087 7.78949 14.1754 8.14036 13.9087L10.0421 12.4842C10.4 12.2175 10.3369 12 9.88071 12H9.10878C8.65966 12 8.61756 11.8386 9.00352 11.6421L10.779 10.7508C11.1719 10.5544 11.1369 10.393 10.6737 10.393H9.90177C9.45264 10.393 9.38247 10.1754 9.74036 9.90874L11.6421 8.48418C12.0351 8.21751 12.5474 8.21751 12.9404 8.48418L14.8421 9.90874C15.2 10.1754 15.1369 10.393 14.6807 10.393H13.9088C13.4597 10.393 13.4176 10.5544 13.8035 10.7508L15.579 11.6421C15.9719 11.8386 15.9369 12 15.4737 12H14.7018C14.2526 12 14.1825 12.2175 14.5404 12.4842L16.4421 13.9087C16.8 14.1754 16.7509 14.3087 16.3158 14.2035L14.6667 13.7894C14.1895 13.6982 13.6912 13.8315 13.3263 14.1614L13.6562 13.8315C13.3474 14.1403 13.3404 14.6386 13.6491 14.9544L14.1263 15.4315C14.4351 15.7403 14.3439 15.993 13.8947 15.993H10.6807C10.2456 15.993 10.1404 15.7403 10.4491 15.4315C10.4562 15.4386 10.9333 14.9544 10.9333 14.9544Z",
					fill: "#14AF5A"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_133`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as LBFlag };
